import { BaseService } from './baseService';
import { PatientClinicalScoreDto, PatientClinicalScoreFormData } from '../types/patientClinicalScore';

class PatientClinicalScoreService extends BaseService<PatientClinicalScoreDto, PatientClinicalScoreFormData> {
    constructor() {
        super('/PatientClinicalScore');
    }
}

export const patientClinicalScoreService = new PatientClinicalScoreService();